// =============================================================
// 航富通 vs 航富通 Nova 对比数据
// 定位：两者客户群体一致、核心功能一致；
//        Nova 是旗舰版，差异在于性能体验、操作便捷性、迭代速度与更多新功能。
// 来源：用户明确口径
// =============================================================

// 对比维度（按新定位）：
//   - 核心功能：一致
//   - 差异化：性能 / 操作便捷性 / 迭代速度 / 新功能 / 专属服务
export const compareRows = [
  { dimension: '定位', standard: '标准版', nova: '旗舰版' },
  { dimension: '核心功能', standard: '开单收银 · 进销存 · 会员 · 报表 · 员工管理', nova: '包含标准版全部功能' },
  { dimension: '客户群体', standard: '审美新零售门店（九大行业）', nova: '审美新零售门店（一致）' },
  { dimension: '操作流畅度', standard: '流畅', nova: '更轻更快 · 更流畅' },
  { dimension: '操作便捷性', standard: '高效便捷', nova: '智能化操作 · 更省心省力' },
  { dimension: '功能迭代速度', standard: '稳定迭代', nova: '更快迭代 · 更快上线新功能' },
  { dimension: '新功能预告', standard: '按版本发布', nova: '优先体验更多新功能' },
  { dimension: '性能优化', standard: '标准性能', nova: '引擎级性能优化' },
  { dimension: '服务支持', standard: '标准服务', nova: '优先服务 / 专属支持' },
]

// 旧的门店数量推荐逻辑已不适用（客户群体一致），保留阈值仅供页面移除参考。
export const STORE_THRESHOLD = null
export const MIN_STORES = 1
export const MAX_STORES = 20



// WEBPACK FOOTER //
// ./src/site/data/compare.js